import "./ShopCart.scss";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import InsLoader from "components/InsLoader/InsLoader";
import CartHeader from "components/Shop/Cart/CartHeader";
import CartItem from "components/Shop/Cart/CartItem";
import EditAddress from "components/Shop/Cart/EditAddress";
import InsButton from "components/InsButton/InsButton";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  getCart,
  addProductToCart,
  removeProductToCart,
  sendUserOrder,
} from "api/shop";
import { refreshAccountData } from "api/account";
import { resetAddress } from "store/actions/storeActions";
import { useEffect } from "react";
import images from "ressources/images";
import { useHistory } from "react-router-dom";

const DeliveryAddress = ({ account, deliveryAddress, onClick }) => {
  const { t } = useTranslation();
  return (
    <div className="delivery_address">
      <div className="title">{t("my_delivery_address")}</div>
      <div className="delivery_address_container">
        <div className="delivery_infos">
          <div className="name">
            {account.firstname} {account.lastname}
          </div>
          <div className="address">
            {deliveryAddress
              ? deliveryAddress.address +
                " - " +
                deliveryAddress.postalCode +
                " " +
                deliveryAddress.city
              : t("add_delivery_address")}
            <div className="additional">
              {deliveryAddress?.address2 ? deliveryAddress.address2 : ""}
            </div>
            <div className="phone_field">
              {deliveryAddress?.phone ?? ""}
            </div>
          </div>
        </div>
        <button className="edit_button" type="button" onClick={onClick}>
           {t("edit")}
        </button>
      </div>
    </div>
  );
};

const ShopCart = () => {
  const { t } = useTranslation();
  const router = useHistory();
  const dispatch = useDispatch();
  const account = useSelector((state) => state.account);
  const deliveryAddress = useSelector((state) => state.store.address);
  const [error, seterror] = useState();
  const [loading, setloading] = useState(true);
  const [editAddress, seteditAddress] = useState(false);
  const [acceptedPrivacyNotice, setacceptedPrivacyNotice] = useState(false);
  const [cart, setcart] = useState();
  const [isApiRunning, setIsApiRunning] = useState(false);

  const toggleEditAddress = () => seteditAddress((prevState) => !prevState);

  const fetchCart = () => {
    getCart().then((cart) => {
      setcart(cart);
      setloading(false);
    });
  };

  useEffect(() => {
    fetchCart();
  }, []);

  const addOneItem = (ean, quantity) => {
    setIsApiRunning(true);
    addProductToCart(ean, quantity).then((cart) => {
      setcart(cart);
      setIsApiRunning(false);
    }).catch(() => {
      setIsApiRunning(false);
    });
  };

  const removeOneItem = (ean, quantity) => {
    removeProductToCart(ean, quantity).then((cart) => {
      setcart(cart);
    });
  };

  const removeProduct = (ean) => {
    removeProductToCart(ean, 0).then((cart) => {
      setcart(cart);
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) {
      return;
    }
    setloading(true);
    sendUserOrder(deliveryAddress)
      .then((data) => {
        refreshAccountData();
        router.replace("/shop/cart/order=" + data.number);
        dispatch(resetAddress());
      })
      .catch((error) => {
        seterror(error);
        setloading(false);
      });
  };

  const isValid = deliveryAddress && cart?.count > 0 && acceptedPrivacyNotice;

  return (
    <div className="cart_page default-layout--min-height">
      <CartHeader />

      {loading ? (
        <InsLoader />
      ) : (
        <div>
          <div className="top_content">
            <div className="item_container">
              {cart.elements ? (
                cart.elements.map((item) => (
                  <CartItem
                    itemDetails={item}
                    isApiRunning={isApiRunning}
                    key={item.ean}
                    picture={
                      item.pictures.length
                        ? item.pictures[0].name.name_333
                        : images.we_are_lol_black
                    }
                    brand={item.brand}
                    name={item.name}
                    points={item.points}
                    quantity={item.quantity}
                    totalCart={cart.total}
                    userPoints={account.points}
                    addOne={() => addOneItem(item.ean, 1)}
                    removeOne={() => removeOneItem(item.ean, 1)}
                    removeProduct={() => removeProduct(item.ean)}
                  />
                ))
              ) : (
                <div className="empty_cart">{t("empty_cart")}</div>
              )}
            </div>
          </div>

          <div className="bottom_content">
            <div className="cart_total">
              {t("total")} : {cart.total} {t("points")}
            </div>

            <DeliveryAddress
              account={account}
              deliveryAddress={deliveryAddress}
              onClick={toggleEditAddress}
            />

            <div className="advertisement">{t("advertisement")}</div>

            <div className="privacy_notice">
              <div className="cb_privacy_notice ins_input ins_input_checkbox mb20 mt20">
                <input
                  id="cb_privacy_notice"
                  name="cb_privacy_notice"
                  checked={acceptedPrivacyNotice}
                  onChange={() =>
                    setacceptedPrivacyNotice((prevState) => !prevState)
                  }
                  type="checkbox"
                />

                <label
                  htmlFor="cb_privacy_notice"
                  dangerouslySetInnerHTML={{
                    __html: t("cb_privacy_notice", {
                      interpolation: { escapeValue: false },
                    }),
                  }}
                ></label>
              </div>

              <div
                dangerouslySetInnerHTML={{
                  __html: t("privacy_notice", {
                    interpolation: { escapeValue: false },
                  }),
                }}
              ></div>

              <div
                dangerouslySetInnerHTML={{
                  __html: t("privacy_notice_bottom", {
                    interpolation: { escapeValue: false },
                  }),
                }}
              ></div>
            </div>

            {error && <div className="order_error">{error}</div>}

            <form onSubmit={handleSubmit}>
              <InsButton
                text={loading ? t("processing") : t("command")}
                disabled={!isValid}
              />
            </form>
          </div>

          {editAddress && <EditAddress onClose={toggleEditAddress} />}
        </div>
      )}
    </div>
  );
};

export default ShopCart;
